import { createStore } from "redux";
import { MapReducer } from "./Reducer/MapReducer";

const store = createStore(MapReducer);

export default store;
